import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React from "react";
import Select from 'react-select';
import ProjectsContext from './ProjectsContext';
import _ from 'lodash';
import { Divider } from '@material-ui/core';
import ProjectSearchListItem from './ProjectSearchListItem'
import SearchIcon from "@material-ui/icons/Search";


const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
    height:40,
  },
  valueContainer: {
    display: 'flex',
    // flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    width: 240,
  },
  chip: {
    margin: '18px',
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  }
 

});

const ListStyles = {
  groupLabel : {
    fontWeight:500,
    color:'black',
    fontSize:14,
    paddingBottom:10
  },
  valueLabel :  {
    fontSize:15,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width:'320px',
  }
};


const inputComponent = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />;

const NoOptionsMessage = props =>
  (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );



const formatGroupLabel = data => (
    <div>
      <div style={ListStyles.groupLabel} >
        <span>{data.label}</span>
      </div>
      <Divider/>
    </div>
);


const Placeholder = props =>
  (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );


const SingleValue = props => {


  const project = JSON.parse(props.children);

  if(!props.selectProps.inputValue && props.selectProps.menuIsOpen) {
    return null;
  }

  return (
    <div style={ListStyles.valueLabel}>
      {project.name}
    </div>
  );
}


const ValueContainer = props => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}


const Menu = (props) => (
  <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
    {props.children}
  </Paper>
);

const Control = (props) =>
  (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );

const Tooltip = (props) => (
  <Tooltip content="Search projects">
    <components.NoOptionsMessage {...props} />
  </Tooltip>
)

const DropdownIndicator = (props) => (
  <div style={{paddingLeft:10}}>
    <SearchIcon/>
  </div>
)


const components = {
  Tooltip,
  Control,
  Menu,
  NoOptionsMessage,
  Option:ProjectSearchListItem,
  Placeholder,
  SingleValue,
  ValueContainer,
  DropdownIndicator,
  DropdownIndicator
};

class ProjectLookupSelect extends React.Component {

  static contextType = ProjectsContext;

  constructor(props) {
    super(props);

    this.state = {
      filteredProjects: [],
      searchTerm: '',
      selectedProject: null,
    }

  }

  componentDidMount()
  {
      this.filterProjects();
  }

  filterProjects()
  {
      // const projects = this.context.actionsRedux.projectFunctions;
      const projects = [];
      if (this.context.projects && this.context.projects.gbus && this.context.projects.gbus.forEach) {
        this.context.projects.gbus.forEach(function (gbu, index) {
            gbu.projects.forEach(function (project, i) {
                projects.push(project);
            });
        });
      }
      else if (this.context.reduxStore && this.context.reduxStore.gbus) {
        let gbus = []; 
        for(let key in this.context.reduxStore.gbus){  
            if(this.context.reduxStore.gbus.hasOwnProperty(key)){  
              gbus.push(this.context.reduxStore.gbus[key]);  
            }  
        }  
  
        if (gbus && gbus.length > 0) {
            for (let gbu of gbus) {
                for (let project of gbu.projects) {
                    projects.push(project);
                };
            };
        }
      }



      if (this.state.searchTerm) {
          this.setState({filteredProjects:[...projects]});
      } else {
          const filteredProjects = projects.filter( project => project.name.includes(this.state.searchTerm));
          this.setState(filteredProjects);
      }
  }
  clearSearch() {
    // const projects = this.context.actionsRedux.projectFunctions;
    const projects = [];
    this.context.projects.gbus.forEach(function (gbu, index) {
        gbu.projects.forEach(function (project, i) {
            projects.push(project);
        });
    });

    this.setState({ filterProjects: [...projects], searchTerm: '' })
  }

  render() {

    // const projects = this.context.actionsRedux.projectFunctions;
    const projects = [];
    if (this.context.projects && this.context.projects.gbus && this.context.projects.gbus.forEach) {
      this.context.projects.gbus.forEach(function (gbu, index) {
          gbu.projects.forEach(function (project, i) {
              projects.push(project);
          });
      });
    }
    else if (this.context.reduxStore && this.context.reduxStore.gbus) {
      let gbus = []; 
      for(let key in this.context.reduxStore.gbus){  
          if(this.context.reduxStore.gbus.hasOwnProperty(key)){  
            gbus.push(this.context.reduxStore.gbus[key]);  
          }  
      }  

      if (gbus && gbus.length > 0) {
          for (let gbu of gbus) {
              for (let project of gbu.projects) {
                  projects.push(project);
              };
          };
      }
    }

    let myProjects = projects.filter(project => _.find(project.functions,{isAssigned:true}) );
    let otherProjects = projects.filter(project => !_.find(project.functions,{isAssigned:true}) );


    const jsonfyProject = project => {
      let json = JSON.stringify(project);
      return { label: json, value : project.id }
    }

    myProjects = myProjects.map(jsonfyProject);

    otherProjects = otherProjects.map(jsonfyProject);

    const selectedValue = this.context.reduxStore.selectedProjectOrGbu ? jsonfyProject(this.context.reduxStore.selectedProjectOrGbu) : undefined;


    let projectGroups = [
        {
            label:"My Projects",
            options:myProjects
            
        },
        {
            label:"Other Projects (Read-Only)",
            options:otherProjects
        }
    ]
    
    const { classes, theme } = this.props;
    const selectStyles = {
      menuList : base => ({
        ...base,
        maxHeight : window.innerHeight - 300
      }),
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };


    return (

      <div>

            <Select
              value={selectedValue}
              inputValue={this.state.searchTerm}
              classes={classes}
              styles={selectStyles}
              options={projectGroups}
              formatGroupLabel={formatGroupLabel}
              components={components}
              onChange={(project) => {
                const selectedProject = JSON.parse(project.label);
                this.context.selectProject(selectedProject);
                this.context.displayFunctionList(true);
              }}
              placeholder="Search Projects"
              onInputChange={(searchTerm) => {
                if (!searchTerm) {
                  this.clearSearch();
                } else {
                  this.setState({ searchTerm })
                  this.filterProjects()
                }
              }}
            />

      </div>
    );
  }
}



export default withStyles(styles, { withTheme: true })(ProjectLookupSelect);
